import { jsx as s } from "react/jsx-runtime";
import { useGetLinkComponentAndProps as k } from "../../../hooks/link/index.js";
import { typographyBodySizeMap as C, typographyBodyLineHeightMap as v } from "../../../styles/typography/typography.js";
import { a as x } from "../../../ActionButton-B77eJAd5.js";
import z from "../Button/utils/getBorderStyleProps.js";
import T from "../Button/utils/getMiscStyleProps.js";
import j from "../Button/utils/getPaddingStyleProps.js";
import { sizeToTypographyBodySizeMap as A } from "../Button/utils/sizeToTypographyBodySizeMap.js";
import G from "../Button/utils/useButtonColorStyleProps.js";
function N({
  to: n,
  newTab: i,
  replace: m = !1,
  onClick: p,
  children: y,
  tone: a = "primary",
  fill: e = "filled",
  size: r = "standard",
  disabled: o = !1,
  loading: t = !1,
  width: f = ["100%", void 0],
  fillHeight: l = !1,
  accessibilityLabel: d,
  state: P
}) {
  const S = T({
    width: f,
    fillHeight: l,
    accessibilityLabel: d,
    disabled: o,
    loading: t
  }), c = G({
    fill: e,
    tone: a,
    disabled: o
  }), g = z(e), u = j(r), B = A[r], { Component: h, linkProps: L } = k({
    to: n,
    disabled: o || t,
    newTab: i,
    replace: m,
    state: P
  });
  return /* @__PURE__ */ s(
    h,
    {
      onClick: (M) => {
        !o && p && p(M);
      },
      ...S,
      ...c,
      ...g,
      ...u,
      ...C[B],
      ...v.large,
      ...L,
      children: /* @__PURE__ */ s(x, { loading: t, size: r, children: y })
    }
  );
}
export {
  N as default
};
